import { MARQUEE_ITEMS } from '../data/site';

function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];

  return (
    <section
      aria-label="제작 범위"
      className="marquee-paused overflow-hidden border-y border-night-line bg-night py-5 text-white sm:py-6"
    >
      <div className="animate-marquee flex w-max items-center gap-10 pr-10 sm:gap-14 sm:pr-14">
        {items.map((item, index) => (
          <span
            key={`${item}-${index}`}
            aria-hidden={index >= MARQUEE_ITEMS.length ? 'true' : undefined}
            className="flex items-center gap-10 text-[15px] font-semibold tracking-tight text-white/85 sm:gap-14 sm:text-lg"
          >
            {item}
            <img src="/logo.png" alt="" width={20} height={18} className="h-4 w-auto opacity-80" />
          </span>
        ))}
      </div>
    </section>
  );
}

export default Marquee;
